import { Link, useLocation } from "react-router-dom";
import { Button } from "reactstrap";

export const areAllValuesIdentical = (data, accessor) => {
  if (!data.length) return true;

  const firstValue =
    typeof accessor === "function"
      ? accessor(data[0])
      : data[0][accessor];

  return data.every((row) => {
    const value =
      typeof accessor === "function"
        ? accessor(row)
        : row[accessor];
    return value === firstValue;
  });
};

export const smartSort = (rowA, rowB, columnId) => {
  const a = rowA.values[columnId];
  const b = rowB.values[columnId];

  // ✅ Handle strings (including empty strings)
  if (typeof a === "string" && typeof b === "string") {
    const aEmpty = a.length === 0;
    const bEmpty = b.length === 0;

    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;   // empty last
    if (bEmpty) return -1;

    return a.toLowerCase().localeCompare(b.toLowerCase());
  }

  // ✅ Handle booleans
  if (typeof a === "boolean" && typeof b === "boolean") {
    return Number(a) - Number(b);
  }

  // ✅ Handle numbers
  if (typeof a === "number" && typeof b === "number") {
    return a - b;
  }

  // ✅ Handle null / undefined
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;

  // ✅ Final fallback
  return String(a).localeCompare(String(b));
};

export const generateColumns = (
  data,
  columnData,
  handleEdit,
  handleView,
  page,
  pageSize,
  ListType,
  pathname
) => {
  // Custom accessor function to handle nested objects and arrays
  const createAccessor = (path) => (row) => {
    return path.reduce((acc, key) => {
      // Check if key is an array index like 'free_trials[0]'
      const arrayMatch = key.match(/(\w+)\[(\d+)\]/);
      if (arrayMatch) {
        const [, arrayKey, index] = arrayMatch;
        return acc && Array.isArray(acc[arrayKey])
          ? acc[arrayKey][Number(index)]
          : "-";
      }
      return acc && acc[key] ? acc[key] : "-";
    }, row);
  };

  const columns = columnData.map((col) => {
    const colPath = col.value.split("."); // Split nested keys
    const displayName = col.label.toUpperCase();
    if (col.value === "index") {
      return {
        Header: displayName,
        id: "rowIndex",
        accessor: (row, i) => page * pageSize + row.index,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
        disableFilters: true,
        filterable: false,
      };
    }

    return {
      Header: displayName,
      accessor: colPath.length > 1 ? createAccessor(colPath) : col.value, // Handle nested paths if present
      sortType: smartSort,
      disableSortBy: areAllValuesIdentical(data, colPath.length > 1 ? createAccessor(colPath) : col.value),
      disableFilters: true,
      filterable: false,
      Cell: ({ value, row }) => {
        // Format date values
        if (["createdAt"].includes(col.value) && value) {
          const date = new Date(value);
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
        }
        if (col.value === "is_active") {
          return value === "Active" || value === false || value === 0 ? (
            <span className="badge bg-danger-subtle text-danger text-uppercase">
              In-active
            </span>
          ) : (
            <span className="badge bg-success-subtle text-success text-uppercase">
              Active
            </span>
          );
        }
        if (col.value === "is_child") {
          return value === "is_child" || value === false || value === 0
            ? "NO"
            : "YES";
        }
        if (col.value === "is_visible_on_mobile") {
          return value === "is_visible_on_mobile" ||
            value === false ||
            value === 0
            ? "NO"
            : "YES";
        }

        if (col.value === "user_type") {
          return (
            {
              1: "Bermad User",
              2: "Subcontractor",
              3: "Customer",
              4: "Subcontractor sub user",
            }[value] || "Unknown"
          );
        }

        if (ListType == "itemList" && col.value === "type") {
          return (
            {
              1: "Make",
              2: "Buy",
            }[value] || "Unknown"
          );
        } else if (col.value === "type") {
          return (
            {
              1: "Bermad",
              2: "Contractor",
            }[value] || "Unknown"
          );
        }
        if (col.value === "origin") {
          return (
            {
              1: "Bermad",
              2: "Local",
            }[value] || "Unknown"
          );
        }

        if (col.value === "actions") {
          const hideEdit = pathname === "/item-intakes-list";

          return (
            <div className="d-flex">
              {!hideEdit && (
                <div
                  onClick={() => {
                    handleEdit(row.original.id);
                  }}
                >
                  <Link className="me-3 text-primary">
                    <i className="mdi mdi-pencil font-size-18"></i>
                  </Link>
                </div>
              )}
              <div
                onClick={() => {
                  handleView(row.original.id);
                }}
              >
                <Link className="me-3 text-primary">
                  <i className="mdi mdi-eye font-size-18"></i>
                </Link>
              </div>
            </div>
          );
        }

        return value;
      },
    };
  });

  return columns;
};
